<script setup lang="ts">
import { FileInterface } from '@/types';
import { EMIT } from '@/enum';
import { toRefs } from 'vue';

interface Props {
  file: FileInterface;
  tag?: string;
}

const props = withDefaults(defineProps<Props>(), { tag: 'li' });
const { file, tag } = toRefs(props);

const emit = defineEmits<{
  (eventName: EMIT.REMOVE, file: FileInterface): void;
}>();
</script>

<template>
  <component :is="tag" class="file-preview relative">
    <div class="col-6 flex align-items-center">
      <span class="material-icons drive w-1rem mx-3">insert_drive_file</span>
      <span class="title font-light my-0 mx-1" v-text="file.file.name"></span>
    </div>
    <div class="col-4">
      <span class="size font-light">{{ file.file.size }} KB</span>
    </div>
    <div class="close absolute right-0 my-0 mx-1 cursor-pointer" @click="emit(EMIT.REMOVE, file)">
      <span class="material-icons">close</span>
    </div>
  </component>
</template>

<style scoped lang="scss">
.file-preview {
  color: $grayDark;
  font-size: 14px;
  line-height: 18px;

  .title {
    color: $grayDark;
  }
}
</style>
